export default {
    title: 'Create Micro-trend',
    intro: 'Micro-trends are new, intelligent, powerful and structure-changing innovations. They can be trend-setting technologies, products, services or new marketing and media innovations. They are the first concrete signs of emerging trends and can be linked to macro-trends.',
    label: 'Link to source',
    action: {
        reset: 'Cancel',
        submit: 'Create without link',
        submitUrl: 'Create'
    },
    error: {
        required: 'Please enter an url',
        url: 'Please enter a valid url'
    }
}
